const Exercise = () => {
    return <div>MyExercise</div>
}
export default Exercise
